import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ManageExamClasses = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/ExaminationSystem/ManageExaminations", { replace: true });
  }, [navigate]);

  return null;
};

export default ManageExamClasses;
